import React from 'react';

export var Fragment = React.Fragment || 'div';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-yandex-maps/es/util/Fragment.js
// module id = 135
// module chunks = 0